import { render } from "./EventClassification.vue?vue&type=template&id=34f04075&scoped=true"
import script from "./EventClassification.vue?vue&type=script&lang=js"
export * from "./EventClassification.vue?vue&type=script&lang=js"

import "./EventClassification.vue?vue&type=style&index=0&id=34f04075&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f04075"]])

export default __exports__